export default __webpack_public_path__ + "static/media/Opposites02_12.9004f240.png";